import Header from './Header/Header';
import Table from 'components/base/Table';
import { TableNoLeftRightBorders } from 'components/base/layout-components';
import LoadingTable from './LoadingTable';
import { handleEditTableMetricsClick } from './GroupMetricsTable.service';
import useGroupTableDataNew from '../hooks/useGroupTableDataNew/useGroupTableDataNew';
import useManagePages from '../hooks/useManagePages/useManagePages';
import { TABLE_PAGE_SIZE } from './GroupMetricsTable.consts';
import useTableLayoutNew from './useTableLayout/useTableLayoutNew';
import useGroupsTeam from '../hooks/useGroupTeams/useGroupTeams';
import useLoading from '../hooks/useLoading/useLoading';
import { SESSION_STORAGE_KEYS } from 'common/constants/constants';
import EmptyData from 'components/EmptyData';
import Text from 'components/base/Text';
import { useState, useEffect } from 'react';

const GroupMetricsDashboardTableNew = ({
  availableMetricsWidgets,
  toggleModal,
  tableColsMetricsNamesInitialStateSettingValue,
  tableMetricsNames,
  setTableMetricsNames,
  tableColsTitlesInitialStateModal,
  updateSetting,
  isCustomizeMetrics,
  setIsTableLoading
}) => {
  const { isRowLoading, setIsRowLoading, tableClassName } = useLoading();
  const [expandedTeamId, setExpandedTeamId] = useState(null);
  const groupsManagedPages = useManagePages(TABLE_PAGE_SIZE);

  const { selectedGroup, selectedGroupChildren, selectedGroupId } =
    useGroupsTeam();

  const {
    isLoadingTable,
    isExpandingTable,
    aggregatedMetrics,
    metricsPerGranularity,
    aggregatedLastPeriodMetrics,
    metricsPerGranularityLastPeriod,
    lastPeriodDates,
    onLoadMoreClick,
    onExpandClick
  } = useGroupTableDataNew({
    groupsManagedPages,
    tableMetricsNames,
    setExpandedTeamId
  });

  useEffect(() => {
    setIsTableLoading(isLoadingTable);
  }, [isLoadingTable]);

  useEffect(() => {
    setIsRowLoading(isExpandingTable);
  }, [isExpandingTable]);

  const isLoading =
    !availableMetricsWidgets.length ||
    isLoadingTable ||
    !tableColsMetricsNamesInitialStateSettingValue;

  const isError = !aggregatedMetrics.length || !metricsPerGranularity.length;

  const { cols, rows } = useTableLayoutNew({
    selectedGroup,
    tableMetricsNames,
    availableMetricsWidgets,
    groupsManagedPages,
    aggregatedMetrics,
    metricsPerGranularity,
    aggregatedLastPeriodMetrics,
    metricsPerGranularityLastPeriod,
    lastPeriodDates,
    onLoadMoreClick,
    onExpandClick,
    isRowLoading,
    expandedTeamId
  });

  if (!isLoading && isError) {
    return (
      <EmptyData
        title='Oops, something went wrong'
        info={
          <Text size='medium' color='shuttleGray'>
            Try refreshing your page. If that doesn't work please contact
            support.{' '}
          </Text>
        }
      />
    );
  }

  return (
    <>
      <Header
        teams={selectedGroupChildren}
        isCustomizeMetrics={isCustomizeMetrics}
        onClick={() =>
          handleEditTableMetricsClick(
            toggleModal,
            availableMetricsWidgets,
            setTableMetricsNames,
            tableColsTitlesInitialStateModal,
            updateSetting,
            selectedGroupId
          )
        }
      />
      {isLoading ? (
        <LoadingTable cols={cols} />
      ) : (
        <TableNoLeftRightBorders
          data-cy='group-teams-metrics-table'
          className={tableClassName}
        >
          <Table
            data={rows}
            columns={cols}
            isRowsDefaultExpanded={false}
            isRowsExpandable={true}
            persistExpandedRowsProps={{
              storageKey:
                SESSION_STORAGE_KEYS.GROUP_DASHBOARD.TABLE.EXPANDED_ROWS_STATE
            }}
          />
        </TableNoLeftRightBorders>
      )}
    </>
  );
};

export default GroupMetricsDashboardTableNew;
